// extracted by mini-css-extract-plugin
export var actions = "layout-module--actions--da1e8";
export var debugInfo = "layout-module--debugInfo--f08bd";
export var header = "layout-module--header--e821e";
export var hint = "layout-module--hint--28137";
export var minimized = "layout-module--minimized--55309";
export var preview = "layout-module--preview--4192e";
export var scrollToTopButton = "layout-module--scrollToTopButton--430e9";
export var withoutHero = "layout-module--withoutHero--46543";